import { useState } from 'react';
import Modal from 'react-modal';
import { useToasts } from 'react-toast-notifications';

import * as LotService from '../../services/Lot';
import * as Utils from '../../utils/global';

import "./publish-logged.scss";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');

const PublishLoggedModal = ({
  modalIsOpen,
  closeModal,
  nextAction,
}: {
  modalIsOpen: any,
  closeModal: any,
  nextAction: any,
}) => {
  const { addToast } = useToasts();

  const [loading, setLoading] = useState<boolean>(false);

  const publishLot = async () => {
    setLoading(true);
    // facebook information
    const fbp = Utils.getFbp();
    const fbc = Utils.getFbc();

    try {
      await LotService.wantPublish({
        fbp,
        fbc,
      });
      setLoading(false);
      nextAction();
    } catch(err) {
      addToast(err.response.data.message, { appearance: 'error' });
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      style={customStyles}
      contentLabel="Login Modal"
    >
      <div className="container">
        <div className="top-actions close">
          <button
            onClick={closeModal}
          >
            <img src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_cancel.svg" alt="close" />
          </button>
        </div>
        <div className="row-top-information" style={{
          marginBottom: "15px"
        }}>
          <h2 style={{
            marginTop: "0"
          }}>Publicá tu Lote</h2>
        </div>
        <div>
          <p>¿Deseas que nos contactemos para que tu ganado quede publicado?</p>
        </div>
        <div className="form-group submit" style={{
          padding: '0 10px',
          marginBottom: '0',
        }}>
          <div className="row">
            <button
              className="btn-continue"
              onClick={() => publishLot()}
              style={{
                width: '100%',
              }}
              disabled={loading}
            >
              Quiero que me llamen
            </button>
          </div>
          <div className="row" style={{
            marginTop: '10px',
          }}>
            <button
              className="btn btn-no"
              onClick={closeModal}
              style={{
                width: '100%',
              }}
              disabled={loading}
            >
              Ahora no
            </button>
          </div>
        </div>
    </div>
  </Modal>);
};

export default PublishLoggedModal;
